import { getOptions } from './PropertyTypeFilter';
import FormattedList from 'I18n/components/FormattedList';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'foundations-theming/utils';
import { Button } from 'foundations-components/transitional/components/Button';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { Flex } from 'foundations-components/components/Flex';
import VerticalBar from '../../../common/VerticalBar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NoShrink = styled.div.withConfig({
  displayName: "PropertyTypeFilterPreview__NoShrink",
  componentId: "sc-1u4ee1-0"
})(["flex-shrink:0;display:flex;align-items:center;"]);
const Shrink = styled.div.withConfig({
  displayName: "PropertyTypeFilterPreview__Shrink",
  componentId: "sc-1u4ee1-1"
})(({
  theme
}) => ({
  flex: '1',
  minWidth: '0',
  whiteSpace: 'nowrap',
  margin: `0 ${theme.space[200]}`
}));
function PropertyTypeFilterPreview({
  propertyTypes,
  onClear
}) {
  if (propertyTypes.length === 0) {
    return null;
  }
  const options = getOptions();
  return /*#__PURE__*/_jsxs(Flex, {
    paddingInline: "400",
    paddingBlockEnd: "400",
    alignItems: "center",
    children: [/*#__PURE__*/_jsxs(NoShrink, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFiltersUI.dataExplorer.typeFilterBar.label"
      }), /*#__PURE__*/_jsx(VerticalBar, {
        marginInlineEnd: "200",
        marginInlineStart: "200"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFiltersUI.dataExplorer.typeFilterBar.propertyTypeLabel"
      })]
    }), /*#__PURE__*/_jsx(Shrink, {
      children: /*#__PURE__*/_jsx(TruncateString, {
        children: /*#__PURE__*/_jsx(FormattedList, {
          children: propertyTypes.map(type => {
            var _options$find;
            return /*#__PURE__*/_jsx("strong", {
              children: (_options$find = options.find(option => option.value === type)) === null || _options$find === void 0 ? void 0 : _options$find.label
            }, type);
          })
        })
      })
    }), /*#__PURE__*/_jsx(NoShrink, {
      children: /*#__PURE__*/_jsx(Button, {
        use: "link",
        onClick: onClear,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFiltersUI.dataExplorer.typeFilterBar.clearAll"
        })
      })
    })]
  });
}
export default PropertyTypeFilterPreview;